import {ProductController} from '@wc-stripe/controllers';
import {getSetting} from '@wc-stripe/utils';
import Context from '@wc-stripe/context';
import {GooglePayGateway} from '@wc-stripe/gateways'

const settings = getSetting('stripe_googlepay_data');

const context = new Context('product');

const gateway = new GooglePayGateway({
    id: 'stripe_googlepay',
    settings,
    context
});

const controller = new ProductController({
    context,
    gateway,
    selector: '#wc-stripe_googlepay-product-button'
});

controller.initialize();